import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUiMenuMediaPlayerController} from "./VanillaReaderUiMenuMediaPlayerController";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiMenuController extends IVanillaReaderUiComponentController, IVanillaReaderUI, VanillaReaderUiMenuMediaPlayerController {}

/**
 * # VanillaReaderUiMenuController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiMenu` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiMenu
 *
 */
export class VanillaReaderUiMenuController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.menuBottom.onMenuHandleClicked(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onMenuHandleSwipeDown(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        //vanillaReaderUiContext.menuBottom.onFileOpen(vanillaReaderUiContext._onMenuBottomFileOpenAction.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onPublicationSearch(vanillaReaderUiContext._onMenuBottomPublicationSearch.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onBookmarkReadingPosition(vanillaReaderUiContext._onMenuBottomBookmarkReadingPosition.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onMenuVisible(vanillaReaderUiContext._onMenuBottomVisible.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onMenuHidden(vanillaReaderUiContext._onMenuBottomHidden.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onHelpOpen(vanillaReaderUiContext._onMenuBottomHelpDialogOpen.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onContentsOpen(vanillaReaderUiContext._onMenuBottomContentsDialogOpen.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onReadAloudControlsOpen(vanillaReaderUiContext._onMenuBottomReadAloudControlsOpen.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onReadAloudControlsClose(vanillaReaderUiContext._onMenuBottomReadAloudControlsClose.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onPanZoomActivate(vanillaReaderUiContext._onPanZoomActivate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onPanZoomDeactivate(vanillaReaderUiContext._onPanZoomDeactivate.bind(vanillaReaderUiContext));
        //vanillaReaderUiContext.menuBottom.onReadingRulerShow(vanillaReaderUiContext._onReadingRulerShow.bind(vanillaReaderUiContext));
        //vanillaReaderUiContext.menuBottom.onReadingRulerHide(vanillaReaderUiContext._onReadingRulerHide.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onNavigationHistoryShow(vanillaReaderUiContext._onNavigationHistoryShow.bind(vanillaReaderUiContext));
    }

    _onMenuBottomPublicationSearch(): void {
        this.dialogSearch.show(false, true, undefined, this.latestSelectedSearchResultLocator);
    };

    _onMenuBottomHandleClicked(): void {
        this.menuBottom.hide(!this.useReducedMotion);
        this.toaster.toast('Menu closed').catch(console.warn);
    };

    _onMenuBottomFileOpenAction(): void {
        this.closePublicationAndShowFileOpenDialog()
    };

    _onMenuBottomBookmarkReadingPosition(): void {
        this.bookmarkReadingPosition();
    };

    _onMenuBottomVisible(): void {
        this.menuBottom.setAsImportantForAccessibility();
        // Let's make sure that the highlight button is not hidden below the menu
        let fabBottomOffset = 16;
        let fabButtonOffset = this.menuBottom.getComponentElement().getBoundingClientRect().height + fabBottomOffset + 'px';
        this.vanillaReaderFabContainerElement.style.marginBottom = fabButtonOffset;
        this.setReaderViewAsNotImportantForAccessibility();
    };

    _onMenuBottomHidden(): void {
        this.menuBottom.setAsNotImportantForAccessibility();
        // Move the highlight button back to its original position
        this.vanillaReaderFabContainerElement.style.marginBottom = '0';

        this.setReaderViewAsImportantForAccessibility();
        this.focusOnReadingPosition();
    };

    _onMenuBottomHelpDialogOpen(): void {
        this.dialogHelp.show(!this.useReducedMotion);
    };

    _onMenuBottomContentsDialogOpen(): void {
        this.dialogContents.show();
    };

    _onMenuBottomReadAloudControlsOpen(startPlaybackWhenReady: boolean = false): void {
        this.openMediaPlayer(startPlaybackWhenReady);
    };

    _onMenuBottomReadAloudControlsClose(): void {
        this.closeMediaPlayer()
    };

    _onPanZoomActivate(): void {
        this.activatePanZoomTool();
    }

    _onPanZoomDeactivate(): void {
        this.deactivatePanZoomTool();
    }

    _onReadingRulerShow(): void {
        this.showReadingRuler();
    }

    _onReadingRulerHide(): void {
        this.hideReadingRuler();
    }

    _onNavigationHistoryShow(): void {
        this.dialogNavigationHistory.show();
    }
}
